import React from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  stats?: React.ReactNode;
  toolbar?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, subtitle, stats, toolbar, className = '' }: PageHeaderProps) {
  return (
    <header className={`page-header ${className}`}>
      <div className="page-header-top">
        <div>
          <h2>{title}</h2>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
        {stats && <div className="header-stats">{stats}</div>}
      </div>
      {toolbar && <div className="page-header-bottom">{toolbar}</div>}
    </header>
  );
}

export interface StatCardProps {
  value: number | string;
  label: string;
  variant?: 'default' | 'frozen' | 'active';
  className?: string;
}

export function StatCard({ value, label, variant = 'default', className = '' }: StatCardProps) {
  return (
    <div className={`header-stat-card ${className}`}>
      <div className={`header-stat-value ${variant}`}>{value}</div>
      <div className="header-stat-label">{label}</div>
    </div>
  );
}

// Export as compound component
PageHeader.StatCard = StatCard;
